import React from 'react';
import { Snackbar, Button, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import './index.scss';

interface UpdateNotificationProps {
  /** Whether the notification is open */
  open: boolean;
  /** Current version of the app */
  currentVersion: string;
  /** New version available */
  newVersion: string | null;
  /** Callback when user clicks update */
  onUpdate: () => void;
  /** Callback when user dismisses the notification */
  onDismiss: () => void;
}

/**
 * UpdateNotification component
 * Shows a notification bar when a new version of the application is available
 */
const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  open,
  currentVersion,
  newVersion,
  onUpdate,
  onDismiss,
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      className="update-notification"
    >
      <Box className="update-notification-content">
        <Box className="update-notification-text">
          <RefreshIcon className="update-notification-icon" />
          <Typography variant="body2" component="span">
            A new version is available
            {newVersion && currentVersion && (
              <span className="version-info">
                ({currentVersion} → {newVersion})
              </span>
            )}
          </Typography>
        </Box>
        <Box className="update-notification-actions">
          <Button
            variant="contained"
            size="small"
            onClick={onUpdate}
            className="update-button"
            startIcon={<RefreshIcon />}
          >
            Update Now
          </Button>
          <IconButton
            size="small"
            onClick={onDismiss}
            className="dismiss-button"
            aria-label="Dismiss update notification"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Snackbar>
  );
};

export default UpdateNotification;
